export default {
      id: "checked-icon-usage",
      viewBox: "0 0 90 71",
      url: __webpack_public_path__ + "icons-sprite.c706496.svg#checked-icon-usage",
      toString: function () {
        return this.url;
      }
    }